import { jwtDecode } from 'jwt-decode'
import { getSessionToken, userLogout } from '@/utils/cache'
import { ElMessage } from 'element-plus'

/** 与后端 JwtUitls.TOKEN_TIMEOUT 对齐，提前 30 秒视为过期 */
const EXPIRY_SKEW_MS = 30 * 1000

export function decodeTokenPayload(token) {
  if (!token) return null
  try {
    return jwtDecode(token)
  } catch {
    return null
  }
}

export function getTokenExpireAtMs(token = getSessionToken()) {
  const payload = decodeTokenPayload(token)
  if (!payload?.exp) return null
  return payload.exp * 1000
}

/** 本地判断 JWT 是否过期（不请求后端） */
export function isTokenExpired(token = getSessionToken(), skewMs = EXPIRY_SKEW_MS) {
  const expMs = getTokenExpireAtMs(token)
  if (expMs == null) return true
  return Date.now() >= expMs - skewMs
}

export function isSessionValid(token = getSessionToken()) {
  return Boolean(token && decodeTokenPayload(token) && !isTokenExpired(token))
}

export function isAuthFailurePayload(data) {
  if (!data) return false
  const code = data.code
  const msg = String(data.message || '')
  return code === 501 || /token|登录|过期|无效/i.test(msg)
}

export function logoutIfExpired(options = {}) {
  const { silent = false, message = '登录已过期，请重新登录' } = options
  if (!getSessionToken() || !isTokenExpired()) return false
  if (!silent) {
    ElMessage.warning({ message, showClose: true })
  }
  userLogout()
  return true
}

/** 路由进入前、定时任务等场景调用 */
export function ensureSessionValid(options = {}) {
  if (isSessionValid()) return true
  if (getSessionToken()) {
    logoutIfExpired(options)
  }
  return false
}

/** 不依赖页面发 API，周期性检查 session 中的 JWT */
export function startSessionExpiryWatcher(intervalMs = 60 * 1000) {
  const tick = () => logoutIfExpired()
  tick()
  const timerId = window.setInterval(tick, intervalMs)
  return () => window.clearInterval(timerId)
}
